import { useLayoutEffect, useRef } from 'react';
import { addAppScrollListener, getAppScrollTarget, getAppScrollTop, scrollAppTo } from '../utils/appViewport';

export default function AppViewport({ children }) {
    const frameRef = useRef(null);

    useLayoutEffect(() => {
        let owner = getAppScrollTarget();
        let scrollTop = getAppScrollTop();
        const removeScrollListener = addAppScrollListener(() => {
            // Changing display/overflow can clamp the old scroller before the
            // resize event. Keep its last position until ownership transfers.
            if (getAppScrollTarget() === owner) scrollTop = getAppScrollTop();
        });
        const reconcileScrollOwner = () => {
            const nextOwner = getAppScrollTarget();
            if (nextOwner === owner) return;
            owner = nextOwner;
            scrollAppTo({ top: scrollTop, left: 0, behavior: 'auto' });
            scrollTop = getAppScrollTop();
        };

        window.addEventListener('resize', reconcileScrollOwner);
        // Pointer capability changes can also change the CSS breakpoint without
        // changing browser dimensions. The frame then gains or loses its box.
        const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(reconcileScrollOwner) : null;
        observer?.observe(frameRef.current);
        return () => {
            removeScrollListener();
            window.removeEventListener('resize', reconcileScrollOwner);
            observer?.disconnect();
        };
    }, []);

    return <div id='appViewport' className='appViewport' ref={frameRef}>
        <div id='appScrollViewport' className='appScrollViewport'>{children}</div>
    </div>;
}
